module.exports = __webpack_public_path__ + "img/icon_camera.58d00c57.svg";